/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Snigdha Dhanireddy <snigdha.dhanireddy@mroads.com>, May 2023
 * @flow
 */

import React from 'react';
import { connect } from 'react-redux';
import { getPopupConfig } from '../../components/Popup';
import API from '../../requests';
import FireboardUtils from '../../util/fireboard-util';
import View from './views';
import { TmsComponents as TmsEnums } from '../../enums';
import { BookingStatuses } from './constants';
import withSocketContext from '../../context-api/SocketContext/withSocketContext';
import UTIL from "mroads-js-utils";
import { TimeConstants } from "../../constants";
import CommonUtil from '../Fireboard/common';
import schedule from 'node-schedule';
import UTILMain from '../../util';

class TMS extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      popup: undefined,
      updatedCustomShapes: new Map(),
      bookings: new Map(),
      bookingStatus: BookingStatuses.find(st => st.statusId === 0),
      bookingCount: {
        waitlist: 0,
        seated: 0,
        cancelled: 0,
      },
      selectedBooking: {},
      bookingList: [],
      selectedShape: null,
      selectedItem: {},
      showCheckDetails: false,
      isCustomSmsType: true,
      customSmsList: [],
      selectedTableChecks: [],
      isEnabledDragDrop: false,
      createWaitlistMode: false,
      editWaitlistMode: false,
      assignTableMode: false,
      menuMode: false,
      showTableProperties: false,
      moveTableInfo: null,
    };
    this.layoutJson = null;
    this.shapes = new Map();
    this.selectedSensorGroup = null;
    this.stationMap = new Map();
    this.checks = new Map();
    this.tableChecks = new Map();
    this.parentChildMergedStations = new Map();
    this.childParentMergedStations = new Map();
    this.regularShapes = new Map();
    this.customShapes = new Map();
    this.mappedChecks = new Map();
    this.currency = '$';
    this.openedChecks = [];
    this.paidChecks = [];
    this.tempSelectedCheck = {};
    this.selectedTablesToSeatParty = [];
    this.tableActionEnabledCriteria = {
      clearTableEnabled: false,
      mergeTableEnabled: false,
      unmergeTableEnabled: false,
      transferTableEnabled: false,
      voidCheckEnabled: false,
    };
    this.labels = {};
  }

  componentDidMount() {
    const { history, reduxProps: { storeInfo, currencyInfo, labelsData } } = this.props;
    if (!storeInfo?.data) {
      history.push({
        pathname: '/',
        state: { deviceTypeId: 12 }
      });
      return;
    }
    this.currency = currencyInfo?.currency;
    this.labels = labelsData?.labels || {};

    this.buildStationMap();
    this.setBookings(this.props?.context?.bookings, this.props?.context?.checks);
    this.scheduleJobs();
    this.getMergedStations();
    this.getCustomSmsTemplates();
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if (this.props?.context !== newProps?.context) {
      const { context: nextContext } = newProps;
      this.setBookings(nextContext?.bookings, nextContext?.checks);

      if (nextContext?.newNotifications && nextContext.newNotifications.length) {
        this.handleNewNotification(nextContext.newNotifications);
      }
    }

    if (this.props?.reduxProps?.labelsData !== newProps?.reduxProps?.labelsData) {
      this.labels = newProps?.reduxProps?.labelsData?.labels || {};
    }
  }

  componentWillUnmount() {
    schedule.gracefulShutdown();
  }

  scheduleJobs = () => {
    //schedule a job - this runs every 1 minute
    schedule.scheduleJob('*/1 * * * *', () => {
      this.updateShapes();
    });
  };

  getLayout = () => {
    const { reduxProps: { storeInfo } } = this.props;
    const { serverAppFeatures, sensorGroups } = storeInfo?.data || {};
    if (serverAppFeatures?.storeLayoutBySensorGroup) {
      const [sensGroup0] = sensorGroups || [];
      const defaultSelectedSensorGrp = { label: sensGroup0?.name, value: sensGroup0?.id };
      this.onSelectSensorGroup(defaultSelectedSensorGrp);
    } else {
      this.getStoreLayout(storeInfo?.data?.id);
    }
  };

  setBookings = (bookings, checks) => {
    const allChecks = Array.from(checks.values());
    let checksMap = new Map();
    allChecks && allChecks.forEach(check => {
      checksMap.set(check.id, CommonUtil.parseCheckFromRedis(check));
    });
    this.checks = checksMap;
    this.updateShapes();
    this.setState({ bookings: bookings }, () => this.filterBookingBasedOnStatus());
  };

  handleNewNotification = newNotifications => {
    const { context: { updateNotification }, reduxProps: { storeInfo } } = this.props;
    const { stations } = storeInfo?.data || {};

    newNotifications.forEach(res => {
      const notificationTypeId = res.value.notificationTypeId;
      const notification = res.value.data;
      const { stationId, mergedStationIds, unMergedStationIds } = notification;
      let updatedCustomShapes = new Map(this.state.updatedCustomShapes);
      if (notificationTypeId === 12) {
        this.parentChildMergedStations.set(stationId, mergedStationIds);
        updatedCustomShapes.set(stationId, this.getUpdatedShape(stationId, updatedCustomShapes.get(stationId)));
        const table = stations.find(s => s.id === stationId);//get primary station object
        const primaryTable = { id: table.id, name: table.name };

        mergedStationIds.forEach(mergedId => {
          this.childParentMergedStations.set(mergedId, primaryTable);
          updatedCustomShapes.set(mergedId, this.getUpdatedShape(mergedId, updatedCustomShapes.get(mergedId)));
        });
        this.setState({ updatedCustomShapes });
      } else if (notificationTypeId === 13) {
        let childIds = this.parentChildMergedStations.get(stationId);
        this.parentChildMergedStations.set(stationId, childIds.filter(id => !unMergedStationIds.includes(id)));
        unMergedStationIds.forEach(unMergedId => {
          this.childParentMergedStations.delete(unMergedId);
          updatedCustomShapes.set(unMergedId, this.getUpdatedShape(unMergedId, updatedCustomShapes.get(unMergedId)));
        });
        this.setState({ updatedCustomShapes });
      }
      updateNotification && updateNotification(res.value.notificationId);
    });
  };

  filterBookingBasedOnStatus = () => {
    const { bookingStatus, bookings } = this.state;
    const bookList = Array.from(bookings.values());
    let bookingList = bookList.filter(booking => booking?.status === bookingStatus?.statusId);
    bookingList.sort(this.sortByBookingDate);
    const waitlistCount = bookList.filter(booking => booking.status === 0).length;
    const seatedCount = bookList.filter(booking => booking.status === 7).length;
    const cancelledCount = bookList.filter(booking => booking.status === 9).length;
    this.setState({
      bookingList,
      bookingCount: {
        waitlist: waitlistCount,
        seated: seatedCount,
        cancelled: cancelledCount,
      },
    });
  };

  sortByBookingDate = (a, b) => {
    const time1 = a?.bookingDate;
    const time2 = b?.bookingDate;
    const timeMS1 = this.getConvertedTime(time1).getTime();
    const timeMS2 = this.getConvertedTime(time2).getTime();
    return timeMS1 - timeMS2;
  };

  getConvertedTime = time => {
    let convertedTime;
    if (time.includes('Z')) {
      convertedTime = new Date(time);
    } else {
      convertedTime = new Date(time + 'Z');
    }
    return convertedTime;
  };

  buildStationMap = () => {
    const { reduxProps: { storeInfo } } = this.props;
    const { stations } = storeInfo?.data || {};
    let mapObj = new Map();
    if (Array.isArray(stations)) {
      stations.forEach(station => mapObj.set(station.id, station));
    }
    this.stationMap = mapObj;
  };

  updateShapes = () => {
    const { selectedShape } = this.state;
    const checksArray = Array.from(this.checks.values());
    let checkMap = new Map(); //new Map<stationId, Array of checks>
    checksArray.forEach(check => {
      if (check.stationId) {
        if (checkMap.has(check.stationId)) {
          checkMap.set(check.stationId, [...checkMap.get(check.stationId), check]);
        } else {
          checkMap.set(check.stationId, [check]);
        }
      }
    });
    this.mappedChecks = checkMap;

    let updatedCustomShapes = new Map(this.customShapes);
    let newTableChecks = new Map();
    const allShapes = Array.from(this.shapes.values());
    allShapes.forEach(shape => {
      const stationId = shape.stationId;
      if (stationId) {
        const assignedCheck = this.mappedChecks.has(stationId) ? this.mappedChecks.get(stationId) : [];
        newTableChecks.set(stationId, assignedCheck);
        updatedCustomShapes.set(stationId, this.getUpdatedShape(stationId, shape));
      }
    });
    this.tableChecks = newTableChecks;
    this.setState({ updatedCustomShapes });
    if (selectedShape) {
      if (selectedShape.stationId) {
        this.onSelectShape(updatedCustomShapes.get(selectedShape.stationId));
      } else {
        this.onSelectShape(selectedShape);
      }
    }
  };

  getUpdatedShape = (stationId, shape) => {
    const assignedCheck = this.mappedChecks.has(stationId) ? this.mappedChecks.get(stationId) : [];
    const { color, occupied } = this.getTableStatus(assignedCheck);
    const { openTime, closedTime, totalAmount, showClosedTime, guestCount } = this.getTableOpenAndCloseTime(assignedCheck);

    const merges = this.parentChildMergedStations.has(stationId)
      ? this.parentChildMergedStations.get(stationId)
      : [];
    const primaryTable = this.childParentMergedStations.has(stationId)
      ? this.childParentMergedStations.get(stationId)
      : null;
    const isTableMerged = !FireboardUtils.isObjectBlank(primaryTable);

    return {
      ...shape,
      stroke: isTableMerged ? '#41a7f5' : color,
      occupied,
      openTime: isTableMerged ? this.labels?.POPUP_MESSAGE_MERGED + `\n(${primaryTable?.name})` : openTime,
      closedTime: isTableMerged ? null : closedTime,
      totalAmount: isTableMerged
        ? null
        : (totalAmount !== null && totalAmount !== undefined) ? `${this.currency}${totalAmount.toFixed(2)}` : null,
      showClosedTime,
      parentStationId: primaryTable ? primaryTable?.id : null,
      mergedStationIds: merges,
      guestCount,
      isTableMerged: isTableMerged || false,
    };
  };

  getTableOpenAndCloseTime = checks => {
    const paidChecks = checks.filter(check => {
      const [order0] = check.orders || [];
      if (check.totalAmount > 0 && check.unpaidAmount === 0 && (order0?.orderStatusId === 0 || order0?.orderStatusId === 1))
        return true;
      return false;
    });
    const openedChecks = checks.filter(check => check.open);

    let openTime;
    let closedTime;
    let totalAmount;
    let showClosedTime = false;
    let guestCount;

    if (openedChecks.length > 0) {
      let openTimeInMS = 0;
      let tAmount = 0;
      openedChecks.forEach(eachCheck => {
        const { openDate, totalAmount: amount } = eachCheck || {};
        const timeInMS = FireboardUtils.getElapsedTimeInMilliseconds(openDate);
        if (openTimeInMS < timeInMS)
          openTimeInMS = timeInMS;
        tAmount += amount;
      });
      openTime = this.showTimeInHrsMins(openTimeInMS);
      totalAmount = tAmount;
    } else if (paidChecks.length > 0) {
      let openTimeInMS = 0;
      let closeTimeInMS = 0;
      paidChecks.forEach(eachCheck => {
        const { openDate, closeDate } = eachCheck || {};
        const openTym = FireboardUtils.getElapsedTimeInMilliseconds(openDate);
        const closeTym = FireboardUtils.getElapsedTimeInMilliseconds(closeDate);
        if (openTimeInMS < openTym)
          openTimeInMS = openTym;
        if (closeTimeInMS < closeTym)
          closeTimeInMS = closeTym;
      });
      openTime = this.showTimeInHrsMins(openTimeInMS);
      closedTime = this.showTimeInHrsMins(closeTimeInMS);
      showClosedTime = true;
    }

    const mergedChecks = [...openedChecks, ...paidChecks];
    if (mergedChecks.length > 0) {
      guestCount = mergedChecks.reduce((total, eachCheck) => {
        return total + eachCheck.guestCount;
      }, 0);
    }

    return { openTime, closedTime, totalAmount, showClosedTime, guestCount };
  };

  showTimeInHrsMins = time => {
    if (!time || time < 0)
      return "00:00";
    const timeInSeconds = parseInt(time / TimeConstants.SECOND);
    const timeInMins = parseInt(timeInSeconds / 60);
    const hrs = parseInt(timeInMins / 60);
    const mins = timeInMins % 60;
    const formattedMins = ('0' + mins).slice(-2);
    return `${hrs}:${formattedMins}`;
  };

  getTableStatus = (checksArray) => {
    let color = 'green';
    let occupied = false;
    if (Array.isArray(checksArray)) {
      if (checksArray.length === 0) {
        color = 'green';
        occupied = false;
      } else {
        const isTableOccupied = checksArray.some(check => {
          const [order0] = check.orders || [];
          if (check.totalAmount > 0 && check.unpaidAmount === 0 && (order0?.orderStatusId === 0 || order0?.orderStatusId === 1))
            return true;
          return false;
        });
        const isCheckOpened = checksArray.some(check => check.open);
        const isCheckAboutToComplete = checksArray.some(check => {
          const [order0] = check.orders || [];
          if (!check.open && (order0?.orderStatusId !== 0 && order0?.orderStatusId !== 1))
            return true;
          return false;
        });

        if (isTableOccupied) {
          color = 'red';
          occupied = true;
        } else if (isCheckOpened) {
          color = 'orange';
          occupied = true;
        } else if (isCheckAboutToComplete) {
          color = 'green';
          occupied = false;
        } else {
          occupied = true;
        }
      }
    }
    return { color, occupied };
  };

  handleErrorPopup = error => {
    const errorMsg = error.response
      ? error.response.data
      : error.message;
    FireboardUtils.addNetworkLogs(error.response);
    this.getPopup("error", null, errorMsg);
  };

  getPopup = (type, heading, message, callback) => {
    const popup =
      type === "spinner"
        ? getPopupConfig("spinner")
        : getPopupConfig("error", () => {
          callback && callback();
          this.setState({ popup: undefined });
        });
    if (heading) {
      popup.heading = heading;
    }
    if (message) {
      popup.message = message;
    }
    this.setState({ popup });
  };

  onClosePopup = () => {
    this.setState({ popup: undefined });
  };

  openPopup = (popupType, booking) => {
    if (booking) {
      this.state.selectedBooking = booking;
    }
    this.setState({ popup: { type: popupType } });
  };

  openTableMenu = () => {
    this.setState({ popup: { type: TmsEnums.showTableMenu } });
  }

  getMergedStations = () => {
    const { reduxProps: { storeInfo, deviceApi, labelsData } } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    const { deviceId } = deviceApi?.data || {};
    let parentToChild = new Map();
    let childToParent = new Map();
    this.getPopup('spinner', this.labels?.POPUP_MESSAGE_GETTING_MERGED_STATIONS_MSG, null);
    API.getMergedTables({ storeId, deviceId })
      .then(response => {
        const stations = response.data;
        stations.forEach(station => {
          const merges = station.merges.map(m => m.id);
          parentToChild.set(station.id, merges);
          merges.forEach(m => childToParent.set(m, { id: station.id, name: station.name }));
        });
        this.parentChildMergedStations = parentToChild;
        this.childParentMergedStations = childToParent;
        this.getLayout();
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  openMergeStationPopup = (shape, check, moveTableFlow) => {
    this.setState({
      popup: {
        type: TmsEnums.mergeTableLookup,
        metaData: {
          selectedShape: {
            ...shape,
            moveTableFlow: moveTableFlow,
          },
          selectedCheck: { ...check },
        },
      }
    });
  };

  seatWithoutTableSelection = () => {
    const { reduxProps } = this.props;
    const { selectedBooking } = this.state;
    const { storeInfo } = reduxProps;
    const { id: bookingId } = selectedBooking || {};
    const callback = () => {
      const payload = {
        storeId: storeInfo.data.id,
        bookingId,
        stationIds: [],
        employeeId: null,
      };
      this.getPopup('spinner', this.labels?.POPUP_MESSAGE_SEAT_GUEST_WITHOUT_TABLE_MSG, null);
      API.bookingComplete(payload)
        .then(response => {
          this.setState({ popup: undefined });
          FireboardUtils.addNetworkLogs(response);
        })
        .catch(error => this.handleErrorPopup(error));
    };
    const popup = getPopupConfig('confirmation');
    popup.heading = this.labels?.POPUP_MESSAGE_CONFIRMATION;
    popup.message = this.labels?.POPUP_MESSAGE_SEAT_GUEST_WITHOUT_TABLE_CONF_MSG;
    popup.buttons = [
      {
        text: this.labels?.POPUP_MESSAGE_YES,
        onClick: () => callback && callback(),
      },
      {
        text: this.labels?.POPUP_MESSAGE_CANCEL,
        onClick: () => this.onClosePopup(),
      },
    ];
    this.setState({ popup });
  };

  onMergeTable = (parentId, childIds) => {
    const { reduxProps } = this.props;
    const { storeInfo, deviceApi } = reduxProps;
    const { deviceId } = deviceApi?.data;

    const payload = {
      storeId: storeInfo.data.id,
      deviceId: deviceId,
      stationId: parentId,
      mergedStationIds: childIds,
    };
    this.getPopup('spinner', this.labels?.POPUP_MESSAGE_MERGING_TABLES_MSG, null);
    API.mergeTable(payload)
      .then(response => {
        this.setState({ popup: undefined });
        this.goToWaitlistScreen();
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  }

  onClickSms = () => {
    if (this.openedChecks.length === 0) return;
    if (this.openedChecks.length === 1) {
      this.onHandleSms(this.openedChecks[0]);
    } else {
      this.setState({
        popup: {
          type: TmsEnums.tmsCheckSelectionPopup,
          metaData: {
            list: this.openedChecks,
            actionText: this.labels?.POPUP_MESSAGE_SEND_SMS,
            allActionText: this.labels?.POPUP_MESSAGE_SEND_SMS_ALL,
            eachAction: this.onHandleSms,
            allAction: this.onClickSendAll,
          }
        }
      });
    }
  };

  onClickSendAll = () => {
    this.setState({
      popup: {
        type: TmsEnums.tmsSms,
        from: 'multiCheck',
      },
    });
  };

  onHandleSms = (check) => {
    this.tempSelectedCheck = check;
    this.setState({
      popup: {
        type: TmsEnums.tmsSms,
        from: 'check',
      },
    });
  };

  onHandleSendAll = (msg, customSmsObj) => {
    const { isCustomSmsType } = this.state;
    const { reduxProps: { storeInfo, deviceApi } } = this.props;
    const { deviceId } = deviceApi?.data;
    const { latitude, longitude } = UTILMain.location;

    const callback = async () => {
      const defaultPayload = {
        latitude,
        longitude,
        deviceId: deviceId,
        storeId: storeInfo?.data?.id,
      };

      const list = [...this.openedChecks];
      let promises = [];
      list.forEach(eachCheck => {
        const { tickets, unpaidAmount, orders, id } = eachCheck;
        const [order0] = orders || [];
        const preauthTicket = tickets && tickets.find(ticket => ticket.ticketStatusId === 0 && ticket.preAuth && unpaidAmount > 0);
        let payload = {
          ...defaultPayload,
          phoneNumber: order0 && order0.phoneNumber ? order0.phoneNumber : null,
          countryCode: order0 && order0.countryCode ? order0.countryCode : null,
          message: msg,
          checkHeaderId: id,
        };
        if (isCustomSmsType) {
          payload = {
            ...payload,
            custom: true,
            templateId: customSmsObj?.id,
          };
        }
        if (preauthTicket) {
          payload['checkTicketId'] = preauthTicket?.id || null;
        }
        promises.push(API.fireboardSendSMS(payload));
      });

      this.getPopup("spinner", this.labels?.POPUP_MESSAGE_SENDING_SMS_MSG, null);
      const results = await Promise.allSettled(promises);
      results.forEach(result => {
        if (result.status === 'fulfilled') {
          try {
            const response = result.value;
            this.onClosePopup();
            FireboardUtils.addNetworkLogs(response);
          } catch (err) {
            console.error('onHandleSendAll() method - error in evaluating fulfilled promise.');
          }
        } else if (result.status === 'rejected') {
          try {
            const error = result.reason;
            this.handleErrorPopup(error)
          } catch (err) {
            console.error('onHandleSendAll() method - error in evaluating rejected promise.');
          }
        }
      });
    };

    const popup = getPopupConfig("confirmation");
    popup.heading = this.labels?.POPUP_MESSAGE_CONFIRMATION;
    popup.message = this.labels?.POPUP_MESSAGE_SEND_SMS_CONF_MSG;
    popup.buttons = [
      {
        text: this.labels?.POPUP_MESSAGE_YES,
        onClick: () => callback && callback(),
      },
      {
        text: this.labels?.POPUP_MESSAGE_CANCEL,
        onClick: () => this.setState({ popup: undefined }),
      },
    ];
    this.setState({ popup });
  };

  openSmsSuccessPopup = (isSuccess, retry) => {
    this.setState({
      popup: {
        type: TmsEnums.tmsSmsSuccess,
        metaData: {
          success: isSuccess,
          retry: retry,
        }
      }
    });
  }

  onHandleSend = (msg, customSmsObj) => {
    if (this.state.popup?.from === 'multiCheck') {
      this.onHandleSendAll(msg, customSmsObj);
      return;
    }

    const payload = this.getSendSmsPayload(msg, customSmsObj, this.state.popup?.from);

    const retry = () => {
      this.getPopup("spinner", this.labels?.POPUP_MESSAGE_SENDING_SMS_MSG, null);
      fireSmsAPI();
    }

    const fireSmsAPI = () => {
      API.fireboardSendSMS(payload)
        .then((resp) => {
          console.debug("responsee from sms api", resp);
          this.openSmsSuccessPopup(true);
          FireboardUtils.addNetworkLogs(resp);
        })
        .catch((error) => {
          console.debug("error from sms api", error, error.response);
          this.openSmsSuccessPopup(false, retry);
          FireboardUtils.addNetworkLogs(error.response);
        });
    }

    const callback = () => {
      this.getPopup("spinner", this.labels?.POPUP_MESSAGE_SENDING_SMS_MSG, null);
      fireSmsAPI();
    };

    const popup = getPopupConfig("confirmation");
    popup.heading = this.labels?.POPUP_MESSAGE_CONFIRMATION;
    popup.message = this.labels?.POPUP_MESSAGE_SEND_SMS_CONF_MSG;
    popup.buttons = [
      {
        text: this.labels?.POPUP_MESSAGE_YES,
        onClick: () => {
          callback && callback();
        },
      },
      {
        text: this.labels?.POPUP_MESSAGE_CANCEL,
        onClick: () => {
          this.setState({ popup: undefined });
        },
      },
    ];
    this.setState({ popup });
  };

  getSendSmsPayload = (msg, customSmsObj, from) => {
    const { isCustomSmsType } = this.state;
    const { reduxProps } = this.props;
    const { storeInfo, deviceApi } = reduxProps;
    const { deviceId } = deviceApi?.data || {};
    const { id: storeId } = storeInfo?.data || {};
    const { latitude, longitude } = UTILMain.location;
    let payload = {
      latitude,
      longitude,
      deviceId,
      storeId,
      message: msg,
    };

    if (isCustomSmsType) {
      payload = {
        ...payload,
        custom: true,
        templateId: customSmsObj?.id,
      };
    }

    if (from === 'booking') {
      const { selectedBooking } = this.state;
      payload = {
        ...payload,
        checkHeaderId: null,
        phoneNumber: selectedBooking?.phoneNumber || null,
        countryCode: selectedBooking?.countryCode || null,
      };
    } else if (from === 'check') {
      const { tickets, unpaidAmount, orders, id } = this.tempSelectedCheck;
      const preauthTicket = tickets && tickets.find(ticket => ticket.ticketStatusId === 0 && ticket.preAuth && unpaidAmount > 0);
      payload = {
        ...payload,
        checkHeaderId: id,
        phoneNumber: orders && orders.length > 0 ? orders[0].phoneNumber : null,
        countryCode: orders && orders.length > 0 ? orders[0].countryCode : null,
      };
      if (preauthTicket) {
        payload['checkTicketId'] = preauthTicket?.id || null;
      }
    }

    return payload;
  };

  onChangeSmsType = () => {
    const { isCustomSmsType } = this.state
    this.setState({ isCustomSmsType: !isCustomSmsType });
  };

  getCustomSmsTemplates = () => {
    const { reduxProps } = this.props;
    const { storeInfo } = reduxProps || {};
    const { id: storeId } = storeInfo?.data || {};
    API.getCustomSmsTemplates(storeId)
      .then(response => {
        let { isCustomSmsType, customSmsList } = this.state;
        isCustomSmsType = (response.data && response.data.length > 0) ? true : false;
        customSmsList = response.data || [];
        this.setState({ isCustomSmsType, customSmsList });
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => {
        this.handleErrorPopup(error);
      });
  };

  initiateMoveTable = () => {
    this.state.moveTableInfo = null;
    const { selectedShape } = this.state;
    const isPaidCheck = selectedShape?.stroke === 'red';
    const checks = isPaidCheck ? this.paidChecks : this.openedChecks;
    if (checks.length === 0) return;
    if (checks.length === 1) {
      this.onClickMoveCheck(checks[0]);
    } else {
      this.setState({
        popup: {
          type: TmsEnums.tmsCheckSelectionPopup,
          metaData: {
            list: checks,
            actionText: this.labels?.POPUP_MESSAGE_MOVE,
            allActionText: this.labels?.POPUP_MESSAGE_MOVE_ALL,
            eachAction: this.onClickMoveCheck,
            allAction: this.onClickMoveAllCheck,
          },
        }
      });
    }
  };

  onClickMoveCheck = (check) => {
    this.setState({
      popup: undefined,
      moveTableInfo: {
        check,
        multiple: false,
        allChecks: [],
      },
    });
  };

  onClickMoveAllCheck = (checks) => {
    this.setState({
      popup: undefined,
      moveTableInfo: {
        check: checks[0],
        multiple: true,
        allChecks: checks,
      },
    });
  };

  onMoveTable = (newStationId) => {
    const { moveTableInfo } = this.state;
    if (moveTableInfo && moveTableInfo?.multiple) {
      this.onMoveAllChecks(newStationId);
      return;
    }

    const { checkHeaderId } = moveTableInfo?.check || {};
    const { reduxProps } = this.props;
    const { storeInfo, deviceApi } = reduxProps;
    const { deviceId } = deviceApi?.data;

    const callback = () => {
      const payload = {
        storeId: storeInfo.data.id,
        deviceId: deviceId,
        checkHeaderId: checkHeaderId,
        stationId: newStationId,
      };
      this.getPopup('spinner', this.labels?.POPUP_MESSAGE_MOVING_GUEST_MSG, null);
      API.moveGuest(payload)
        .then(response => {
          this.onClosePopup();
          this.clearMoveTableInfo();
          FireboardUtils.addNetworkLogs(response);
        })
        .catch(error => this.handleErrorPopup(error));
    };

    callback && callback();
  };

  onMoveAllChecks = (newStationId) => {
    const { reduxProps } = this.props;
    const { storeInfo, deviceApi } = reduxProps;
    const { deviceId } = deviceApi?.data;
    const { moveTableInfo } = this.state;

    const callback = async () => {
      const defaultPayload = {
        storeId: storeInfo.data.id,
        deviceId: deviceId,
        stationId: newStationId,
      };
      const list = moveTableInfo?.allChecks ? moveTableInfo.allChecks : [];
      let promises = [];
      list.forEach(eachCheck => {
        promises.push(API.moveGuest({
          ...defaultPayload,
          checkHeaderId: eachCheck.checkHeaderId,
        }));
      });

      this.getPopup("spinner", this.labels?.POPUP_MESSAGE_MOVING_GUEST_MSG, null);
      const results = await Promise.allSettled(promises);
      results.forEach(result => {
        if (result.status === 'fulfilled') {
          try {
            const response = result.value;
            this.onClosePopup();
            this.clearMoveTableInfo();
            FireboardUtils.addNetworkLogs(response);
          } catch (err) {
            console.error(' onMoveAllChecks() method - error in evaluating fulfilled promise.');
          }
        } else if (result.status === 'rejected') {
          try {
            const error = result.reason;
            this.handleErrorPopup(error)
          } catch (err) {
            console.error(' onMoveAllChecks() method - error in evaluating rejected promise.');
          }
        }
      });
    };

    callback && callback();
  };

  clearMoveTableInfo = () => {
    this.setState({ moveTableInfo: null });
  };

  invokeTableUnmerge = () => {
    const { selectedShape } = this.state;
    const { reduxProps } = this.props;
    const { storeInfo, deviceApi } = reduxProps;
    const { deviceId } = deviceApi?.data;

    const payload = {
      storeId: storeInfo.data.id,
      deviceId: deviceId,
      stationId: selectedShape.parentStationId || selectedShape.stationId,
      mergedStationIds: selectedShape.parentStationId ? [selectedShape.stationId] : selectedShape.mergedStationIds,
    };
    this.getPopup('spinner', this.labels?.POPUP_MESSAGE_UNMERGING_TABLES_MSG, null);
    API.unMergeTable(payload)
      .then(response => {
        this.goToWaitlistScreen();
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  }

  getStoreLayout = storeId => {
    this.getPopup('spinner', this.labels?.POPUP_MESSAGE_FETCHING_STORE_LAYOUT_MSG, null);
    API.getStoreLayout(storeId)
      .then(response => {
        let { layoutJson } = response.data;
        this.layoutJson = layoutJson;
        this.parseLayoutJson(layoutJson);
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  parseLayoutJson = layoutJson => {
    try {
      let shapes = new Map();
      const parsedShapes = JSON.parse(layoutJson);
      if (parsedShapes && Object.keys(parsedShapes).length !== 0 && parsedShapes.constructor === Object) {
        shapes = new Map(Object.entries(parsedShapes));
      }
      this.shapes = shapes;
      let regularShapes = new Map();
      let customShapes = new Map();
      const allShapes = Array.from(shapes.values());
      allShapes.forEach(shape => {
        if (shape?.stationId) { //custom shape
          customShapes.set(shape.stationId, { ...shape });
        } else { //regular shape
          regularShapes.set(shape.id, { ...shape });
        }
      });
      this.regularShapes = regularShapes;
      this.customShapes = customShapes;
      this.state.popup = undefined;
      this.updateShapes();
    } catch (error) {
      console.error(`Error in layoutJson parsing - ${error}`);
    }
  };

  getElapsedTime = (elapsedTime) => {
    if (!elapsedTime)
      return "- -";
    const time = Math.abs(elapsedTime);
    const convertedTimeInSeconds = parseInt(time / TimeConstants.SECOND);
    if (convertedTimeInSeconds < 60)
      return `${UTIL.round(convertedTimeInSeconds, 0)}s`;
    const convertedTimeInMinutes = convertedTimeInSeconds / 60;
    if (convertedTimeInMinutes < 120)
      return `${UTIL.round(convertedTimeInMinutes, 0)}m`;

    return "2h+";
  };

  getCheckElapsedTime = check => {
    const elapsedTime = FireboardUtils.getElapsedTime(check);
    this.getElapsedTime(elapsedTime);
  };

  getFormattedCheck = check => {
    const { reduxProps: { currencyInfo } } = this.props;
    const { iso2 } = currencyInfo || {};
    const { paidIcon, preAuthIcon } = FireboardUtils.getPaidStatusIcon(check);
    return {
      id: check.id,
      number: check.number,
      ellapsedTime: this.getCheckElapsedTime(check),
      orderStatusId: check.orders && check.orders.length > 0 ? check.orders[0].orderStatusId : null,
      unpaidAmount: check.unpaidAmount,
      paidAmount: check.paidAmount,
      checkHeaderId: check.id,
      totalAmount: check.totalAmount,
      unseatGuest: this.unseatGuest,
      open: check.open,
      stationName: check.stationName,
      employeeFirstName: check.employeeFirstName,
      employeeLastName: check.employeeLastName,
      storeId: check.storeId,
      paid: preAuthIcon || paidIcon,
      sourceType: check.sourceType,
      orders: check.orders,
      items: check.items,
      tickets: check.tickets,
      stationName: check.stationName,
      deliverTo: FireboardUtils.getDeliverTo(check),
      slotName: '',
      phoneNumber: check.phoneNumber ? FireboardUtils.formattedPhoneNumber(check.phoneNumber, iso2) : "- -",
      selectedCheckDetails: check,
    };
  };

  unseatGuest = () => {
    const { selectedTableChecks = [] } = this.state;
    if (selectedTableChecks.length === 1) {
      this.markAsDone(selectedTableChecks[0]);
    } else if (selectedTableChecks.length > 1) {
      this.setState({
        popup: {
          type: TmsEnums.tmsCheckSelectionPopup,
          metaData: {
            list: selectedTableChecks,
            actionText: this.labels?.POPUP_MESSAGE_UNSEAT_GUEST,
            allActionText: this.labels?.POPUP_MESSAGE_UNSEAT_ALL_GUEST,
            eachAction: this.markAsDone,
            allAction: this.markAllAsDone,
          },
        },
      });
    }
  }

  markAsDone = (item) => {
    const { reduxProps } = this.props;
    const { storeInfo, deviceApi } = reduxProps;
    const { deviceId } = deviceApi?.data;
    this.getPopup("spinner", this.labels?.POPUP_MESSAGE_CLEARING_TABLE_MSG, null);
    API.orderStatusUpdate({
      storeId: storeInfo.data.id,
      deviceId: deviceId,
      checkHeaderId: item.checkHeaderId,
      orderStatusId: 5,
    })
      .then((response) => {
        console.debug("response from orderStatusUpdate", response);
        this.checks.set(response.data.id, CommonUtil.parseCheckFromRedis(response.data));
        this.goToWaitlistScreen();
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  markAllAsDone = async () => {
    const { reduxProps: { storeInfo, deviceApi } } = this.props;
    const { deviceId } = deviceApi?.data || {};
    const { id: storeId } = storeInfo?.data || {};
    const { selectedTableChecks = [] } = this.state;
    const defaultPayload = {
      storeId,
      deviceId,
      orderStatusId: 5,
    };

    let promises = [];
    selectedTableChecks.forEach(eachCheck => {
      promises.push(API.orderStatusUpdate({
        ...defaultPayload,
        checkHeaderId: eachCheck.checkHeaderId,
      }));
    });

    this.getPopup("spinner", this.labels?.POPUP_MESSAGE_CLEARING_TABLE_MSG, null);
    const results = await Promise.allSettled(promises);
    results.forEach(result => {
      if (result.status === 'fulfilled') {
        try {
          const response = result.value;
          this.checks.set(response?.data?.id, CommonUtil.parseCheckFromRedis(response?.data));
          this.goToWaitlistScreen();
          FireboardUtils.addNetworkLogs(response);
        } catch (err) {
          console.error(' markAllAsDone() method - error in evaluating fulfilled promise.');
        }
      } else if (result.status === 'rejected') {
        try {
          const error = result.reason;
          this.handleErrorPopup(error)
        } catch (err) {
          console.error(' markAllAsDone() method - error in evaluating rejected promise.');
        }
      }
    });
  };

  closeShapeInfoPopup = () => {
    this.setState({
      selectedShape: null,
      selectedItem: {},
      popup: undefined,
    });
  };

  onSelectShape = (selectedShape) => {
    if (selectedShape?.stationId) {
      const stationId = selectedShape.stationId;
      const checkList = this.tableChecks.get(stationId);
      const paidChecks = checkList.filter(check => {
        const [order0] = check.orders || [];
        if (check.totalAmount > 0 && check.unpaidAmount === 0 && (order0?.orderStatusId === 0 || order0?.orderStatusId === 1))
          return true;
        return false;
      });
      const openedChecks = checkList.filter(check => check.open);

      const isTableOccupied = paidChecks && paidChecks.length > 0;

      let filteredPaidCheck = {}
      if (Array.isArray(paidChecks) && paidChecks.length > 0)
        filteredPaidCheck = this.getFormattedCheck(paidChecks[0])
      else if (Array.isArray(openedChecks) && openedChecks.length > 0)
        filteredPaidCheck = this.getFormattedCheck(openedChecks[0]);

      const tableChecks = [...paidChecks, ...openedChecks];
      const selectedTableChecks = tableChecks.map(el => this.getFormattedCheck(el));

      //storing paid-checks & opened-checks to class variables
      this.paidChecks = (Array.isArray(paidChecks) && paidChecks.length > 0) ? paidChecks : [];
      this.openedChecks = (Array.isArray(openedChecks) && openedChecks.length > 0) ? openedChecks : [];

      //table action enable criteria
      const { parentStationId, mergedStationIds } = selectedShape || {};
      this.tableActionEnabledCriteria = {
        clearTableEnabled: isTableOccupied,
        mergeTableEnabled: !parentStationId,
        unmergeTableEnabled: parentStationId || (mergedStationIds && mergedStationIds.length > 0),
        transferTableEnabled: tableChecks.length > 0,
        voidCheckEnabled: this.openedChecks.length > 0,
      };

      this.setState({
        selectedShape,
        selectedItem: { ...filteredPaidCheck },
        selectedTableChecks,
        showTableProperties: true,
      });
    }
  };

  onSelectSensorGroup = sensorGroup => {
    this.selectedSensorGroup = sensorGroup;
    const { reduxProps } = this.props;
    const { storeInfo } = reduxProps;
    const { id: storeId } = storeInfo?.data || {};
    this.getPopup('spinner', this.labels?.POPUP_MESSAGE_FETCHING_STORE_LAYOUT_MSG, null);
    API.getStoreLayoutBySensorGroup(storeId, sensorGroup?.value)
      .then(response => {
        let { layoutJson } = response.data;
        this.layoutJson = layoutJson;
        this.parseLayoutJson(layoutJson);
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  onChangeBookingStatus = (bookingStatus) => {
    this.setState({ bookingStatus }, () => this.filterBookingBasedOnStatus());
  };

  onBookingActionClick = (actionType, booking) => {
    if (booking) {
      this.state.selectedBooking = booking;
    }
    switch (actionType) {
      case 'editWaitlist': {
        this.setState({ editWaitlistMode: true });
        break;
      }
      case 'seatParty': {
        this.setState({ assignTableMode: true });
        break;
      }
      case 'clearSeating': {
        this.onClearSeating();
        break;
      }
      case 'cancelWaitlist': {
        this.onCancelBooking();
        break;
      }
      case 'smsGuest': {
        this.setState({
          popup: {
            type: TmsEnums.tmsSms,
            from: 'booking',
          }
        });
        break;
      }
      default:
        console.warn(`${actionType} case not handled!`);
        break;
    }
  };

  onClearSeating = () => {
    const { reduxProps: { storeInfo } } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    const { selectedBooking } = this.state;
    const { id: bookingId, name, stationId } = selectedBooking || {};
    // const station = this.stationMap.has(stationId) ? this.stationMap.get(stationId) : {};
    // const stationNumber = station?.number || '';

    const callback = () => {
      const payload = {
        storeId,
        bookingId,
      };
      this.getPopup('spinner', this.labels?.POPUP_MESSAGE_CLEARING_BOOKING_MSG, null);
      API.bookingClear(payload)
        .then(response => {
          this.setState({ popup: undefined });
          FireboardUtils.addNetworkLogs(response);
        })
        .catch(error => this.handleErrorPopup(error));
    };

    const popup = getPopupConfig('confirmation');
    popup.heading = this.labels?.POPUP_MESSAGE_CONFIRMATION;
    popup.message = this.labels?.POPUP_MESSAGE_MOVE_TO_WAITLIST_CONF_MSG;
    popup.buttons = [
      {
        text: this.labels?.POPUP_MESSAGE_YES,
        onClick: () => callback && callback(),
      },
      {
        text: this.labels?.POPUP_MESSAGE_CANCEL,
        onClick: () => this.onClosePopup(),
      },
    ];
    this.setState({ popup });
  };

  onCancelBooking = () => {
    const { reduxProps: { storeInfo } } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    const { selectedBooking } = this.state;
    const { id: bookingId, name } = selectedBooking || {};

    const callback = () => {
      const payload = {
        storeId,
        bookingId,
      };
      this.getPopup('spinner', this.labels?.POPUP_MESSAGE_CANCELING_BOOKING_MSG, null);
      API.bookingCancel(payload)
        .then(response => {
          this.setState({ popup: undefined });
          FireboardUtils.addNetworkLogs(response);
        })
        .catch(error => this.handleErrorPopup(error));
    };

    const popup = getPopupConfig('confirmation');
    popup.heading = this.labels?.POPUP_MESSAGE_CONFIRMATION;
    popup.message = this.labels?.POPUP_MESSAGE_CANCEL_WAITLIST_CONF_MSG + ` ${name}`;
    popup.buttons = [
      {
        text: this.labels?.POPUP_MESSAGE_YES,
        onClick: () => callback && callback(),
      },
      {
        text: this.labels?.POPUP_MESSAGE_CANCEL,
        onClick: () => this.onClosePopup(),
      },
    ];
    this.setState({ popup });
  };

  onCreateBooking = payload => {
    this.getPopup('spinner', this.labels?.POPUP_MESSAGE_CREATING_NEW_BOOKING_MSG, null);
    API.bookingCreate(payload)
      .then(response => {
        this.setState({ popup: undefined });
        this.goToWaitlistScreen();
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  onUpdateBooking = payload => {
    this.getPopup('spinner', this.labels?.POPUP_MESSAGE_UPDATING_BOOKING_MSG, null);
    API.bookingUpdate(payload)
      .then(response => {
        this.setState({ popup: undefined });
        this.goToWaitlistScreen();
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  showEmployeeList = (tables) => {
    this.selectedTablesToSeatParty = tables;
    this.setState({ popup: { type: 'employeeSelection' } });
  }

  onAssignTable = (employee, stationIds) => {
    const { selectedBooking } = this.state;
    const { reduxProps: { storeInfo } } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    const { id: bookingId } = selectedBooking || {};

    const payload = {
      storeId,
      bookingId,
      stationIds,
      employeeId: employee ? employee.id : null,
    };
    this.getPopup('spinner', this.labels?.POPUP_MESSAGE_ASSIGNING_TABLE_MSG, null);
    API.bookingComplete(payload)
      .then(response => {
        this.setState({ popup: undefined });
        this.goToWaitlistScreen();
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  }

  onSeatParty = (tables, employee) => {
    const { reduxProps: { storeInfo } } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    const { selectedBooking } = this.state;
    const { id: bookingId, name } = selectedBooking || {};
    let stationIds = [];
    let stationNumbers = '';
    if (Array.isArray(tables)) {
      stationIds = tables.map(each => each.stationId);
      stationNumbers = tables.map(each => each.stationNumber).join(', ');
    }

    const callback = () => {
      const payload = {
        storeId,
        bookingId,
        stationIds,
        employeeId: employee ? employee.id : null,
      };
      this.getPopup('spinner', this.labels?.POPUP_MESSAGE_SEATING_PARTY_MSG, null);
      API.bookingComplete(payload)
        .then(response => {
          this.setState({ popup: undefined });
          FireboardUtils.addNetworkLogs(response);
        })
        .catch(error => this.handleErrorPopup(error));
    };

    const popup = getPopupConfig('confirmation');
    popup.heading = this.labels?.POPUP_MESSAGE_CONFIRMATION;
    popup.message = this.labels?.POPUP_MESSAGE_SEAT_PARTY_CONF_MSG + ` ${name} ` + this.labels?.POPUP_MESSAGE_TO_TABLE + ` ${stationNumbers}`;
    popup.buttons = [
      {
        text: this.labels?.POPUP_MESSAGE_YES,
        onClick: () => callback && callback(),
      },
      {
        text: this.labels?.POPUP_MESSAGE_CANCEL,
        onClick: () => this.onClosePopup(),
      },
    ];
    this.setState({ popup });
  };

  onMoveBooking = payload => {
    this.getPopup('spinner', this.labels?.POPUP_MESSAGE_MOVING_BOOKING_MSG, null);
    API.bookingMove(payload)
      .then(response => {
        this.setState({ popup: undefined });
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  onSyncChecks = () => {
    const { reduxProps: { storeInfo }, context } = this.props;
    const { cachingProvider } = storeInfo?.data || {};
    if (cachingProvider) { //CApi Websocket
      this.getPopup('spinner', this.labels?.POPUP_MESSAGE_SYNCING_WITH_POS_MSG, null);
      const { getStoreChecksCApi, getStoreBookingsCApi } = context;
      const successCallback = () => this.setState({ popup: undefined });
      getStoreChecksCApi && getStoreChecksCApi(successCallback);
      getStoreBookingsCApi && getStoreBookingsCApi(successCallback);
    }
  };

  showHelpPopup = fromHeader => {
    this.setState({
      popup: {
        type: TmsEnums.helpPopup,
        meta: { fromHeader: fromHeader || false }
      }
    })
  }

  onToggleCheckDetailsPopup = () => {
    this.setState(prevState => ({
      showCheckDetails: !prevState.showCheckDetails,
    }));
  };

  onVoidCheck = () => {
    const { reduxProps: { storeInfo, deviceApi } } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    const { deviceId } = deviceApi?.data || {};
    const { selectedTableChecks } = this.state;
    this.getPopup('spinner', this.labels?.POPUP_MESSAGE_VOIDING_CHECK_MSG, null);
    const { id } = selectedTableChecks.length > 0 ? selectedTableChecks[0] : {};
    const payload = {
      storeId,
      deviceId,
      checkHeaderId: id,
    };
    API.voidCheck(payload)
      .then(response => {
        const check = response.data;
        this.checks.set(check.id, CommonUtil.parseCheckFromRedis(check));
        this.goToWaitlistScreen();
        this.updateShapes();
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  onToggleDrapDrop = () => {
    this.setState(prevState => ({
      isEnabledDragDrop: !prevState.isEnabledDragDrop
    }));
  };

  onAddGuest = () => {
    this.setState({ createWaitlistMode: true });
  };

  goToWaitlistScreen = () => {
    this.setState({
      createWaitlistMode: false,
      editWaitlistMode: false,
      menuMode: false,
      assignTableMode: false,
      showTableProperties: false,
      selectedShape: null,
      selectedItem: {},
      popup: undefined,
    });
  };

  onOpenMenu = () => {
    this.setState({ menuMode: true });
  };

  onMenuClick = (menuType) => {
    switch (menuType) {
      case 'syncChecks': {
        this.goToWaitlistScreen();
        this.onSyncChecks();
        break;
      }
      case 'layoutDesign': {
        const { history } = this.props;
        history && history.push('/playground');
        break;
      }
      case 'about': {
        this.setState({ popup: { type: TmsEnums.tmsAbout } });
        break;
      }
      case 'help': {
        this.setState({ popup: { type: TmsEnums.helpPopup } });
        break;
      }
      case 'tableSensor': {
        const { history } = this.props;
        history && history.push('/tableSensors');
        break;
      }
      case 'namedSensor': {
        const { history } = this.props;
        history && history.push('/namedSensors');
        break;
      }
      default: console.warn(`${menuType} case not handled`);
    }
  };

  get viewProps() {
    const {
      popup,
      updatedCustomShapes,
      bookingList,
      bookingStatus,
      bookingCount,
      selectedBooking,
      selectedItem,
      selectedShape,
      showCheckDetails,
      isCustomSmsType,
      customSmsList,
      selectedTableChecks,
      isEnabledDragDrop,
      createWaitlistMode,
      editWaitlistMode,
      menuMode,
      assignTableMode,
      showTableProperties,
      moveTableInfo,
    } = this.state;
    const { reduxProps: { storeInfo, currencyInfo } } = this.props;
    const { iso2 } = currencyInfo;
    const currency = currencyInfo?.currency || '$';
    const { employees } = storeInfo?.data || {};
    const shapes = [...Array.from(updatedCustomShapes.values()), ...Array.from(this.regularShapes.values())];

    return {
      popup,
      shapes,
      bookingList,
      bookingStatus,
      bookingCount,
      selectedBooking,
      showCheckDetails,
      selectedSensorGroup: this.selectedSensorGroup,
      employees: employees,
      selectedItem: selectedItem,
      selectedShape: selectedShape,
      stationMap: this.stationMap,
      storeInfo: storeInfo?.data,
      isCustomSmsType,
      customSmsList,
      iso2,
      currency,
      selectedTableChecks,
      isEnabledDragDrop,
      createWaitlistMode,
      editWaitlistMode,
      menuMode,
      assignTableMode,
      showTableProperties,
      moveTableInfo,
      tableChecks: this.tableChecks,
      tableActionEnabledCriteria: this.tableActionEnabledCriteria,
      onChangeSmsType: this.onChangeSmsType,
      onHandleSend: this.onHandleSend,
      onClickSms: this.onClickSms,
      closeShapeInfoPopup: this.closeShapeInfoPopup,
      openPopup: this.openPopup,
      onSelectShape: this.onSelectShape,
      onClosePopup: this.onClosePopup,
      onSelectSensorGroup: this.onSelectSensorGroup,
      onChangeBookingStatus: this.onChangeBookingStatus,
      onBookingActionClick: this.onBookingActionClick,
      onCreateBooking: this.onCreateBooking,
      goToWaitlistScreen: this.goToWaitlistScreen,
      onUpdateBooking: this.onUpdateBooking,
      onSeatParty: this.onSeatParty,
      showEmployeeList: this.showEmployeeList,
      onMoveBooking: this.onMoveBooking,
      onMergeTable: this.onMergeTable,
      openMergeStationPopup: this.openMergeStationPopup,
      invokeTableUnmerge: this.invokeTableUnmerge,
      seatWithoutTableSelection: this.seatWithoutTableSelection,
      onMoveTable: this.onMoveTable,
      onToggleCheckDetailsPopup: this.onToggleCheckDetailsPopup,
      showHelpPopup: this.showHelpPopup,
      initiateMoveTable: this.initiateMoveTable,
      openTableMenu: this.openTableMenu,
      onVoidCheck: this.onVoidCheck,
      onToggleDrapDrop: this.onToggleDrapDrop,
      onAddGuest: this.onAddGuest,
      onOpenMenu: this.onOpenMenu,
      onMenuClick: this.onMenuClick,
      onAssignTable: this.onAssignTable,
      unseatGuest: this.unseatGuest,
      clearMoveTableInfo: this.clearMoveTableInfo,
    };
  }

  render() {
    const viewProps = this.viewProps;
    return (
      <View  {...viewProps} />
    );
  }
}

const mapStateToProps = (reduxProps) => ({
  reduxProps,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(withSocketContext(TMS));
